module.exports = __webpack_public_path__ + "static/media/frank-Bizzle.f34560cf.png";